export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src="/brand/logo-icons.png"
    alt="Sy Sy's Snacks icons"
    className={`${className} h-auto w-auto shrink-0`}
    style={{ height: 40 }}
  />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-10 w-10 shrink-0 transition-transform duration-300 group-hover:rotate-6" />
    <span className="leading-none">
      <span className={`font-logo block text-xl ${dark ? "text-cream" : "text-ink"}`}>Sy Sy's</span>
      <span
        className={`block pt-0.5 text-[10px] font-black uppercase tracking-[0.32em] ${
          dark ? "text-sunburst" : "text-tomato"
        }`}
      >
        Snacks
      </span>
    </span>
  </span>
);

export default Logo;
